@if (showLoadingComponent()) {
  <app-loading-page title="PARTNER CORE" [isLoading]="isLoading()"></app-loading-page>
}
<router-outlet></router-outlet>
<app-clip-recording-indicator></app-clip-recording-indicator>
<app-video-call-overlay></app-video-call-overlay>